module.exports = "modal-body-custom {\n  overflow-y: auto;\n  overflow-x: auto;\n  max-height: 80vh;\n  padding: 1px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/forms/all/dynamic-forms/dynamic-forms.component.scss
// module id = ./src/app/forms/all/dynamic-forms/dynamic-forms.component.scss
// module chunks = main